module.exports = __webpack_public_path__ + "static/media/FicusEducation_Logo_Secondary_CMYK.0f1cad04.png";